import React from 'react';
import { colors } from '../theme';
import { useLang } from '../i18n/LanguageContext';

export type LuggageStatus = 'PENDING' | 'PAID';

interface Props {
  status?: LuggageStatus | null;
}

const TEXT = {
  cs: {
    PENDING: 'Úschova zavazadel: požadováno, zatím není schváleno a zaplaceno',
    PAID: 'Úschova zavazadel: schváleno a zaplaceno',
  },
  en: {
    PENDING: 'Luggage storage: requested, not yet approved and paid',
    PAID: 'Luggage storage: approved and paid',
  },
};

/**
 * One suitcase for the whole reservation, whichever side of the stay the luggage is on. Amber is
 * the same "somebody asked, nobody has settled" as on the hours beside it; green means every
 * requested side is approved and paid. Any value this build does not know is drawn amber — an
 * unrecognised status must never read as settled.
 */
const LuggageStatusIcon: React.FC<Props> = ({ status }) => {
  const { lang } = useLang();
  if (!status) return null;

  const paid = status === 'PAID';
  const label = TEXT[lang === 'cs' ? 'cs' : 'en'][paid ? 'PAID' : 'PENDING'];

  return (
    <span
      role="img"
      aria-label={label}
      title={label}
      data-luggage-status={paid ? 'PAID' : 'PENDING'}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        flexShrink: 0,
        borderRadius: 3,
        padding: '1px 3px',
        cursor: 'help',
        background: paid ? colors.badgeGreenBg : colors.badgeOrangeBg,
        color: paid ? colors.badgeGreenText : colors.badgeOrangeText,
      }}
    >
      <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
           style={{ display: 'block' }}>
        <rect x="5" y="7" width="14" height="13" rx="2" />
        <path d="M9 7V4.5A1.5 1.5 0 0 1 10.5 3h3A1.5 1.5 0 0 1 15 4.5V7" />
        <path d="M9 11v5M15 11v5" />
      </svg>
    </span>
  );
};

export default LuggageStatusIcon;
